export const isValidAccountNumber = (value: string) =>
  /^\d{6,17}$/.test(value);
